import {
  Address,
  DepositLocation,
  WithdrawalLocation,
} from '@varo/graphql-schema-types';
import { openURL } from 'expo-linking';
import { Platform } from 'react-native';
import { isWeb } from 'shared/constants/platform';

export default function openMarkerInMaps(
  marker: WithdrawalLocation | DepositLocation,
) {
  const scheme = Platform.select({
    ios: 'maps://0,0?q=',
    android: 'geo:0,0?q=',
    web: 'http://maps.google.com/maps/search/',
  });
  const latLng = `${marker?.coordinate?.latitude},${marker?.coordinate?.longitude}`;
  const label = encodeURI(marker?.name);
  const { addressLine1, addressLine2, city, state, zip } =
    marker?.address as Address;

  const address = encodeURI(
    `${addressLine1 ? `${addressLine1} ` : ''}${addressLine2 ? `${addressLine2} ` : ''}${city ? `${city} ` : ''}${state ? `${state} ` : ''}${zip ? `${zip}` : ''}`,
  );

  const url = Platform.select({
    ios: `${scheme}@${latLng}&address=${address}`,
    android: `${scheme}${latLng}(${label})`,
    web: `${scheme}${address}`,
  });

  if (isWeb) {
    window.open(`${scheme}${address}`, 'target=_blank');
    return;
  }

  void openURL(url as string);
}
